/**
 * Route copy for `src/routes/onboarding` (keys: `routes.onboarding.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  onboardingWizard: {
    tooManyRequestsWaitAMoment: 'Too many requests — wait a moment, then try again.',
    somethingWentWrongPleaseTryAgain: 'Something went wrong. Please try again.',
    welcome: 'Welcome!',
    letSQuicklySetUpYour: 'Let\'s quickly set up your space',
    for: 'for',
    toWorkIn: 'to work in',
    threeStepsAreAllItTakes: '. Three steps are all it takes — you can skip any of them and come back later.',
    inviteATeammate: 'Invite a teammate',
    workTogetherSendAnInvitationBy: 'Work together: send an invitation by email. It\'s optional — you can skip this step.',
    invitationSentTo: 'Invitation sent to',
    teammateSEmail: 'Teammate\'s email',
    firstnameCompanyCom: 'firstname@company.com',
    role: 'Role',
    sending: 'Sending…',
    sendInvitation: 'Send invitation',
    connectAPlatform: 'Connect a platform',
    linkAFirstSocialNetworkTo: 'Link a first social network to publish and track your performance. Optional — you can do it later from “Connected accounts”.',
    loadingPlatforms: 'Loading platforms…',
    noPlatformIsConfiguredYetYou: 'No platform is configured yet. You can connect one later from the “Connected accounts” tab in settings.',
    connectablePlatforms: 'Connectable platforms',
    connected: 'Connected',
    opening: 'Opening…',
    reconnect: 'Reconnect',
    connect: 'Connect',
    firstSignInAssistant: 'First sign-in assistant',
    skip: 'Skip',
    previous: 'Previous',
    finishing: 'Finishing…',
    finish: 'Finish',
    next: 'Next',
  },
};

export default en;
